<template>
  <v-app>
    <body>
      <router-view></router-view>
    </body>
  </v-app>
</template>

<script>
import Vue from "vue";
export default Vue.extend({
  computed: {
    getThemeColor() {
      return this.$store.getters.getThemeColor;
    },
  },
  name: "App",

  data: () => ({
    //
  }),
  methods: {},
});
</script>
